import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { LoadingSpinner } from 'legacy-packages/ft-cb';
import { withApollo } from 'react-apollo';
import log from 'chameleon/ui-stack/utilities/log';
import { GENERATE_ANSWER_SHEET_CONTENT } from 'chameleon/ui-stack/ui/assignment-overview/info-panel/action-buttons/popOverContents';
import './index.scss';

class DownloadAnswerSheetTitle extends Component {
  static propTypes = {
    className: PropTypes.string,
    variables: PropTypes.object,
    getURLFromResponse: PropTypes.func,
    downloadFreshCopy: PropTypes.bool,
    displayTittle: PropTypes.bool,
    onDownload: PropTypes.func,
  };

  static defaultProps = {
    className: null,
    variables: {},
    getURLFromResponse: () => {},
    downloadFreshCopy: false,
    displayTittle: true,
    onDownload: () => {},
  };

  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      url: null,
    };

    this.onClick = this.onClick.bind(this);
  }

  onClick() {
    const { url } = this.state;
    const { downloadFreshCopy, onDownload } = this.props;
    if (url && !downloadFreshCopy) {
      download(url);
      onDownload(downloadFreshCopy);
    } else {
      const { query, variables, getURLFromResponse } = this.props;
      this.setState(
        {
          loading: true,
        },
        () => {
          this.props.client
            .query({
              query,
              fetchPolicy: 'network-only',
              variables,
            })
            .then((resp) => {
              const urlFromResponse = getURLFromResponse(resp);
              this.setState({
                loading: false,
                url: urlFromResponse,
              });
              download(urlFromResponse);
              onDownload(downloadFreshCopy);
            })
            .catch((error) => {
              this.setState({
                loading: false,
              });
              log('error', error);
            });
        },
      );
    }
  }

  onKeyDown = (event) => {
    if (event.keyCode === 13 || event.keyCode === 32) {
      this.onClick();
    }
  };

  render() {
    const { className, hasFrqs, assessmentName, displayTittle } = this.props;
    const { loading } = this.state;
    const titleP1 = hasFrqs
      ? `Select answer sheet layout options for each FRQ on ${assessmentName}.`
      : `Preview the answer sheet for ${assessmentName}.`;

    /**
     * Only show loader if parent is ready to start
     * */
    return (
      <div className={className}>
        <div className="DownloadTestBooklet__container">
          {displayTittle && (
            <Fragment>
              <>
                {GENERATE_ANSWER_SHEET_CONTENT}
                <br />
                {titleP1} Reference your
              </>
              <span className="DownloadTestBooklet__link-and-spinner">
                {loading && (
                  <div className="DownloadTestBooklet__loading">
                    <LoadingSpinner />
                    <div className="text">This may take up to 30 seconds.</div>
                  </div>
                )}
                <span
                  className={cn('DownloadTestBooklet__link', {
                    'DownloadTestBooklet__link-disabled': loading,
                  })}
                  onClick={this.onClick}
                  role="button"
                  tabIndex={0}
                  onKeyDown={this.onKeyDown}
                >
                  &nbsp;test books&nbsp;
                </span>
              </span>
              to view full question text.
            </Fragment>
          )}
        </div>
      </div>
    );
  }
}

const download = (url) => {
  window.location.href = url;
};

export default withApollo(DownloadAnswerSheetTitle);
